import React, { useState, useEffect } from 'react';
// import Styled from 'Styled-components';
import Styled from 'styled-components';
import Image from '../loggedout/common/Image';
import Image1 from '~images/mela-purchase/preferred-plan.png';
// import singlePlanInsteadOfELA from '~images/mela-purchase/ ';
import { device } from '../../utils/responsive_utilities';
import { fontQuicksand} from './mixin';
import PreferredPlanModalImage from './preferred-plan-modal-image';
const PreferredPlanModal = ({switchToYearlyPlan, ModalCloseHandler, subjectsLength,filterTabList, savePercentage,preferrPlanModalContent, defaultShorterPlanDuration}) => {
  useEffect(() =>{
    trackAnalyticsEvent(`${defaultShorterPlanDuration} to Yearly Popup Shown`);
  },[]);

  return (
    <div className="overlay">
      <PreferredPlan>
        <CloseBtn onClick={()=>ModalCloseHandler()}>
          <i className="iconcust-iconCrossBtn"></i>
        </CloseBtn>
        <Head>
          {preferrPlanModalContent.header1}
        </Head>
        <Head>{preferrPlanModalContent.header2}</Head>
        <ImageSection>
          {preferrPlanModalContent.image2Path ?
          <React.Fragment>
            <PreferredPlanModalImage image={preferrPlanModalContent.image1Path} header={preferrPlanModalContent.image1Header} title={preferrPlanModalContent.image1Text} subtitle={preferrPlanModalContent.image1Subtitle} type={preferrPlanModalContent.image1Type}/>
            <PlusSection>+</PlusSection>
            <PreferredPlanModalImage image={preferrPlanModalContent.image2Path} header={preferrPlanModalContent.image2Header} title={preferrPlanModalContent.image2Text} subtitle={preferrPlanModalContent.image2Subtitle} type={preferrPlanModalContent.image2Type}/>
          </React.Fragment>
          :
          <PreferredPlanModalImage image={preferrPlanModalContent.image1Path} header={preferrPlanModalContent.image1Header} title={preferrPlanModalContent.image1Text} subtitle={preferrPlanModalContent.image1Subtitle} type={preferrPlanModalContent.image1Type}/>
          }

        </ImageSection>
        {preferrPlanModalContent.subtitle ? <SubHead>{preferrPlanModalContent.subtitle}</SubHead> : null}
        <CtaButton bgWhite onClick={()=>switchToYearlyPlan(false)}>{preferrPlanModalContent.firstCta}</CtaButton>
        <CtaButton onClick={()=>switchToYearlyPlan(true)}>{preferrPlanModalContent.secondCta}</CtaButton>
      </PreferredPlan>
    </div>
  )
}
export default PreferredPlanModal;

export const PreferredPlan = Styled.div`
  width: 68.3rem;
  position: absolute;
  border-radius: 3.5rem;
  background: #141975;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 4.8rem 4rem;
  text-align: center;
  box-sizing: border-box;
  @media ${device.PhoneLargeScreen} {
    width: 39.5rem;
    padding: 2.4rem 0;
  }
  @media ${device.Phone} {
    width: 34rem;
    padding: 2.4rem 0;
  }
`;

export const Head = Styled.h2`
  ${fontQuicksand(2.8, 3.2, 7)}
  color: #fff;
  @media ${device.PhoneLargeScreen} {
    ${fontQuicksand(1.6, 2.2, 7)}
  }
  @media ${device.Phone} {
    ${fontQuicksand(1.6, 2.2, 7)}
  }
`;

export const SubHead = Styled.p`
  ${fontQuicksand(2, 2.4, 7)};
  padding: 1.2rem;
  color: #fff;
  @media ${device.PhoneLargeScreen} {
    ${fontQuicksand(1.2, 1.6, 7)}
    padding: 0.4rem;
  }
  @media ${device.Phone} {
    ${fontQuicksand(1.2, 1.6, 7)}
    padding: 0.4rem;
  }
`;

export const ImageSection = Styled.div`
  padding: 2rem 0 1.5rem;
  text-align: center;
  display: inline-flex;
  @media ${device.PhoneLargeScreen} {
    padding: 0.2rem 0;
  }
  @media ${device.Phone} {
    padding: 0.2rem 0;
  }
`;

export const PlusSection = Styled.div`
  ${fontQuicksand(6.4, 8.0, 7)};
  color: #FFFFFF;
  text-shadow: 0px 4px 0px rgba(0, 0, 0, 0.25);
  transform: rotate(-10.02deg);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1.5rem 0 1rem;
  @media ${device.PhoneLargeScreen} {
    ${fontQuicksand(2, 4.0, 7)};
  }
  @media ${device.Phone} {
    ${fontQuicksand(2, 4.0, 7)};
  }
`;

export const CtaButton = Styled.div`
  cursor: pointer;
  width: 33.6rem;
  border-radius: 3.3rem;
  background-color: ${props=> props.bgWhite ? '#fff': ''};
  color: ${props=> props.bgWhite ? '#141975': '#fff'};
  border: 1px solid #fff;
  ${fontQuicksand(2, 2.4, 7)}
  padding: 1.8rem 0;
  margin: 0 auto;
  &:last-of-type {
    margin-top: 1.6rem;
  }
  @media ${device.PhoneLargeScreen} {
    width: 28rem;
    padding: 1.2rem 0;
    ${fontQuicksand(1.6, 2.2, 7)};
    &:last-of-type {
      margin-top: 1.2rem;
    }
  }
  @media ${device.Phone} {
    width: 28rem;
    padding: 1.2rem 0;
    ${fontQuicksand(1.6, 2.2, 7)};
    &:last-of-type {
      margin-top: 1.2rem;
    }
  }
`;

export const CloseBtn = Styled.span`
  cursor: pointer;
  position: absolute;
  top: 0;
  right: -5rem;
  width: 4.2rem;
  display: flex;
  height: 4.2rem;
  border-radius: 50%;
  justify-content: center;
  background-color: #141975;
  i {
    opacity: 0.5;
    font-size: 2rem;
    align-self: center;
  }
  @media ${device.PhoneLargeScreen} {
    width: 2.4rem;
    height: 2.4rem;
    right: -3rem;
    i {
      opacity: 0.5;
      font-size: 1rem;
    }
  }
  @media ${device.Phone} {
    width: 2.4rem;
    height: 2.4rem;
    right: 0;
    top: -3rem;
    i {
      opacity: 0.5;
      font-size: 1rem;
    }
  }
`;